import { FaBolt, FaBox, FaBriefcase, FaChair, FaLayerGroup, FaMedal, FaReceipt, FaStar, FaUtensils, FaWineGlassAlt, } from "react-icons/fa";
const META = {
    BILL_DISCOUNT: { label: "BILL DISCOUNT", icon: FaReceipt, iconColor: "#7DD3FC", tint: "#1F2E3A", videoFile: "bill-discount-offers.mp4" },
    FOOD_OFFERS: { label: "FOOD", icon: FaUtensils, iconColor: "#FB923C", tint: "#3A1F1F", videoFile: "food-offers.mp4" },
    DRINKS_OFFERS: { label: "DRINKS", icon: FaWineGlassAlt, iconColor: "#F472B6", tint: "#3A1F2E", videoFile: "drinks-offers.mp4" },
    COMBOS: { label: "COMBOS", icon: FaLayerGroup, iconColor: "#A78BFA", tint: "#2E1F3A", videoFile: "combos-offers.mp4" },
    TABLE_DISCOUNTS: { label: "TABLE DISCOUNT", icon: FaChair, iconColor: "#38BDF8", tint: "#1F2E3A", videoFile: "table-discount-offers.mp4" },
    INSTANT_OFFERS: { label: "INSTANT OFFER", icon: FaBolt, iconColor: "#FACC15", tint: "#3D2E1A", videoFile: "instant-offers.mp4" },
    PACKAGES: { label: "PACKAGE", icon: FaBox, iconColor: "#34D399", tint: "#1F3A2E", videoFile: "packages-offers.mp4" },
    CORPORATE_PACKAGES: { label: "CORPORATE", icon: FaBriefcase, iconColor: "#94A3B8", tint: "#1F2E3A", videoFile: "corporate-offers.mp4" },
    LOYALTY_DISCOUNT: { label: "LOYALTY", icon: FaMedal, iconColor: "#FBBF24", tint: "#3D2E1A", videoFile: "loyalty-offers.mp4" },
    CUSTOM_OFFERS: { label: "OFFER", icon: FaStar, iconColor: "#F59E0B", tint: "#2E1F3A", videoFile: "custom-offers.mp4" },
};
const DEFAULT_META = {
    label: "OFFER",
    icon: FaStar,
    iconColor: "#F59E0B",
    tint: "#222222",
    videoFile: "/offers/offers-page/loyalty-offers.mp4",
};
export const getOfferCategoryMeta = (offer) => {
    var _a, _b;
    const t = (_b = (_a = offer.criteria) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.toUpperCase();
    return (t && META[t]) || DEFAULT_META;
};
